<template>
  <div class="portal-pdf-viewer">
    <iframe
      v-if="canPreviewInline"
      title="Vista previa del informe"
      class="portal-pdf-viewer__frame"
      :src="iframeSrc"
    />

    <div v-else class="portal-pdf-viewer__open-panel">
      <v-icon :icon="pdfIcon" size="44" color="primary" />
      <v-btn
        v-if="pdfObjectUrl"
        color="primary"
        variant="flat"
        :href="pdfObjectUrl"
        target="_blank"
        rel="noopener"
      >
        Abrir informe
      </v-btn>
    </div>
  </div>
</template>

<script>
import icons from "../../utils/enums/icons";

function isAndroidBrowser() {
  if (typeof navigator === "undefined") return false;
  return /Android/i.test(navigator.userAgent || "");
}

export default {
  name: "PortalPdfViewer",
  props: {
    blob: {
      type: Blob,
      default: null,
    },
  },
  data() {
    return {
      pdfIcon: icons.FILE_PDF_BOX,
      pdfObjectUrl: null,
      isAndroid: isAndroidBrowser(),
    };
  },
  computed: {
    canPreviewInline() {
      return !!this.pdfObjectUrl && !this.isAndroid;
    },
    iframeSrc() {
      const base = this.pdfObjectUrl;
      if (!base) return "";
      try {
        const u = new URL(base);
        u.hash = "view=FitH";
        return u.href;
      } catch {
        return `${base}#view=FitH`;
      }
    },
  },
  watch: {
    blob: {
      immediate: true,
      handler() {
        this.refreshObjectUrl();
      },
    },
  },
  beforeUnmount() {
    this.revokeObjectUrl();
  },
  methods: {
    refreshObjectUrl() {
      this.revokeObjectUrl();
      if (this.blob) this.pdfObjectUrl = URL.createObjectURL(this.blob);
    },
    revokeObjectUrl() {
      if (!this.pdfObjectUrl) return;
      URL.revokeObjectURL(this.pdfObjectUrl);
      this.pdfObjectUrl = null;
    },
  },
};
</script>

<style scoped>
.portal-pdf-viewer {
  width: 100%;
  height: 100%;
  min-height: 0;
  background: #202124;
}
.portal-pdf-viewer__frame {
  width: 100%;
  height: 100%;
  min-height: 0;
  border: 0;
  display: block;
}
.portal-pdf-viewer__open-panel {
  height: 100%;
  min-height: 240px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  color: rgba(255, 255, 255, 0.86);
  text-align: center;
  padding: 24px;
}
</style>
